
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ReceiptMaterialDetailsGrid extends Serenity.EntityGrid<ReceiptMaterialDetailsRow, any> {
        protected getColumnsKey() { return 'Production.ReceiptMaterialDetails'; }
        protected getDialogType() { return ReceiptMaterialDetailsDialog; }
        protected getIdProperty() { return ReceiptMaterialDetailsRow.idProperty; }
        protected getInsertPermission() { return ReceiptMaterialDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptMaterialDetailsRow.localTextPrefix; }
        protected getService() { return ReceiptMaterialDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}